// Meta Pixel loader + tracker.
// No-op when REACT_APP_META_PIXEL_ID is empty — safe to ship before credentials.
import { v4 as uuid } from "uuid";

const PIXEL_ID = (process.env.REACT_APP_META_PIXEL_ID || "").trim();
let initialized = false;

export function metaEnabled() {
  return Boolean(PIXEL_ID);
}

export function newEventId() {
  return uuid();
}

export function initMetaPixel() {
  if (!PIXEL_ID || initialized || typeof window === "undefined") return;
  initialized = true;
  if (window.fbq) return;

  // Standard Meta Pixel snippet
  const fbq = function () {
    fbq.callMethod
      ? fbq.callMethod.apply(fbq, arguments)
      : fbq.queue.push(arguments);
  };
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];
  window.fbq = fbq;
  window._fbq = fbq;

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);

  fbq("init", PIXEL_ID);
}

/** Fire a browser Pixel event; eventID must match the server-side event_id.
 *  If fbevents.js hasn't loaded yet, retries every 250ms up to ~5s.
 */
export function trackMeta(name, params = {}, eventId) {
  const id = eventId || newEventId();
  if (!PIXEL_ID || typeof window === "undefined") return id;

  const attempt = (tries = 0) => {
    if (window.fbq && window.fbq.loaded !== false) {
      try {
        window.fbq("track", name, params, { eventID: id });
      } catch (_) {}
      return;
    }
    if (tries < 20) setTimeout(() => attempt(tries + 1), 250);
  };
  attempt();
  return id;
}
